import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import HistoryList from './HistoryList.js';
import { actions } from './HistoryList.actions';
import {
    mainSelector,
    getListPostbacks,
    getHeaderName
} from './HistoryList.selectors';
import {
    getStatuses,
    getConversionStatuses,
    getActionTypes,
    getActionNames
} from '../../../../selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderName,
    list: mainSelector,
    postbacks: getListPostbacks,
    statuses: getStatuses,
    conversionStatuses: getConversionStatuses,
    actionTypes: getActionTypes,
    actionNames: getActionNames
});

const HistoryListComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            page: state.postbackHistory.page,
            total: state.postbackHistory.total,
            loading: state.postbackHistory.loading
        };
    },
    null
)(HistoryList);

export default HistoryListComponent;
